import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { LiveIcon } from 'src/components'
import { useUser } from 'src/hook/useUser'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import { LiveTxt, LiveIconBox } from './liveActiveHeader.styles'
import { LiveActiveHeaderProps } from './liveActiveHeader.types'

const LiveActiveHeader = ({ watchCount = 0, className }: LiveActiveHeaderProps) => {
  const { t } = useTranslation()
  const { theme } = useUser()

  const watchersInThousands = watchCount / 1000
  const participants =
    Math.floor(watchersInThousands) > 0 ? `${watchersInThousands.toFixed(1)}K` : watchCount

  return (
    <div className={clsx('_d-flex _align-items-center', className)}>
      <LiveIconBox
        invert={theme === ThemeMode.DARK}
        className="_d-flex _align-items-center _justify-content-center _mr-1"
      >
        <LiveIcon data-test="live-badge" />
      </LiveIconBox>
      <h3 className="_text-uppercase _text-1 _m-0">
        <LiveTxt className="_font-weight-bold" $theme={theme as ThemeMode}>
          {t('live.in_live')}
        </LiveTxt>
        {watchCount ? (
          <>
            <span>
              {' - '}
              {participants}{' '}
            </span>
            <span>{t('live.watching')}</span>
          </>
        ) : null}
      </h3>
    </div>
  )
}

export default LiveActiveHeader
